import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueGtm from 'vue-gtm';

// MoMA - GTM-NHWPNLJ
// CHIPS Testing - GTM-KKMGLC5

Vue.use(VueGtm, {
	id: 'GTM-NHWPNLJ', // Your GTM ID
	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
	debug: false, // Whether or not display console logs debugs (optional)
});

Vue.prototype.$http = axios

// var $ = require('jquery');
// var inView = require('in-view');
// var Flickity = require('flickity');
// require('intersection-observer');

Vue.config.productionTip = false

new Vue({
	el: '#app',
	render: h => h(App),
	data: {
		pageTitle:'',
		introActive:null,
		introAuto:true
	},
	watch: {
		pageTitle(newTitle) {
			if(newTitle === ''){
				document.title = 'MoMA through Time';
			} else {
				document.title = newTitle + ' - MoMA through Time';
			}
		}
	}
}).$mount('#app')
